import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import podetailImage from "../../assests/images/Po details.png";
import summaryImage from "../../assests/images/Summary.png";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import rejectImage from "../../assests/images/Reject.png";
import { UserObj } from "../../services/localStarage";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Paper from "@mui/material/Paper";
import SupportChat from "../support/chat";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";


const initialColumns = [
  { id: "productid.", label: "Product ID.", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "Productname", label: "Product Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "batchname", label: "Batch Name", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "pcs/boxid", label: "PCS/BOX ID", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "poquantity", label: "PO Quantity", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "deliveredquantitiy", label: "Delivered Quantitiy", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "asnquantitiy", label: "ASN Quantitiy", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "pendingquantitiy", label: "Pending Quantitiy", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
  { id: "totalvalue", label: "Total Value", isSort: true, sortLabel: "", isSearchInput: false, inputText: "", formate: "TEXT" },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];

function AsnDetail() {
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openasnsubmitsuccessfully, setOpenAsnSubmitSuccessfullys] =
    useState(false);
  const [openasncancelsuccessfully, setOpenAsnCancelSuccessfullys] =
    useState(false);
  const onSortChange = (index, sortBy, sortOrder) => {
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
  }
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };
  const userRole = UserObj ? UserObj?.role?.name : "";
  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });
  const [columns, setColumns] = useState(initialColumns);
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);

  const onPaginationChange = (e, value) => {
    // let requestPayloadInit = _.cloneDeep(requestPayload);
    // requestPayloadInit.pageNumber = value;
    // setRequestPayload(requestPayloadInit); 
  }
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  const DrawerList = (
    <Box
      sx={{
        width: 350,
        zIndex: 1300,
      }}
      role="presentation"
    >
      <List>
        <div className="row_order_sidebar_bdpt_po_div">
          <div className="track_order_form_bdpt_sm">
            <h6 className="main_heading_trackordertexr">Track Order</h6>
            <div>
              <CachedOutlinedIcon />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={toggleDrawer(false)}
              ></button>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">PO Number</h6>
              <p className="username_bpdt_div_react_row1">00234</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Status</h6>
              <p class="date_solutions_status_row">Pending</p>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">Creation Date</h6>
              <p className="username_bpdt_div_react_row1">12-02-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Target Date</h6>
              <p className="username_bpdt_div_react_row1">16-03-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Delivery Date</h6>
              <p className="username_bpdt_div_react_row1">19-03-2024</p>
            </div>
          </div>
        </div>
      </List>
      <Divider />
      <List>
        <div>
          <Box className="po_detail_bfdt_row_div_sidebar1 trackorder_section">
            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step style={{ display: "-webkit-box" }} key={index} expanded>
                  {index === 0 || index === 1 ? (
                    <div>
                      {" "}
                      <StepLabel>{step.label}</StepLabel>
                      <StepContent>
                        {step.headings && (
                          <Typography sx={{ mt: 1 }}>
                            {step.headings}
                          </Typography>
                        )}
                        {step.text && (
                          <Typography sx={{ mt: 1 }}>{step.text}</Typography>
                        )}
                        {step.remarks && (
                          <Typography sx={{ mt: 1 }}>{step.remarks}</Typography>
                        )}
                        <Typography>{step.description}</Typography>
                      </StepContent>
                      <StepContent>
                        {step.headings2 && (
                          <Typography
                            className="stepcontent_block_body"
                            sx={{ mt: 1 }}
                          >
                            {step.headings2}
                          </Typography>
                        )}
                        {step.remarks2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.remarks2}
                          </Typography>
                        )}
                        {step.description2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.description2}
                          </Typography>
                        )}
                        {step.text2 && (
                          <Typography sx={{ mt: 1 }}>{step.text2}</Typography>
                        )}
                      </StepContent>{" "}
                    </div>
                  ) : (
                    <div>
                      <StepLabel>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            {step.label}
                          </AccordionSummary>

                          <AccordionDetails>
                            {step.headings && (
                              <Typography sx={{ mt: 1 }}>
                                {step.headings}
                              </Typography>
                            )}
                            {step.text && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text}
                              </Typography>
                            )}
                            {step.remarks && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks}
                              </Typography>
                            )}
                            <Typography>{step.description}</Typography>

                            {step.headings2 && (
                              <Typography
                                className="stepcontent_block_body"
                                sx={{ mt: 1 }}
                              >
                                {step.headings2}
                              </Typography>
                            )}
                            {step.remarks2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks2}
                              </Typography>
                            )}
                            {step.description2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.description2}
                              </Typography>
                            )}
                            {step.text2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text2}
                              </Typography>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </StepLabel>
                    </div>
                  )}
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
      </List>
    </Box>
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_main">
              <h5>ASN Details</h5>
            </div>
            <div className="create_listing_project">
              <div>
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={open ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={open ? "true" : undefined}
                  onClick={handleClick}
                >
                  <LayersIcon />
                  Action
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleClose}>Hold</MenuItem>
                  <MenuItem onClick={handleClose}>Recall</MenuItem>
                  <MenuItem onClick={handleClose}>Cancel ASN</MenuItem>
                  <MenuItem onClick={handleClose}>Request for QC</MenuItem>
                </Menu>
              </div>
              <div className="track_order_react_row">
                <button
                  onClick={toggleDrawer(true)}
                  class="vendor_btn vendor_maine_contents"
                >
                  Track Order
                </button>

                <Drawer
                  anchor="right"
                  open={state.open}
                  onClose={toggleDrawer(false)}
                  style={{ zIndex: 99999 }}
                >
                  {DrawerList}
                </Drawer>
              </div>
              <div>
                <Button
                  className="vendor_btn vendor_maine_contents"
                  id="basic-button"
                  aria-controls={download ? "basic-menu" : undefined}
                  aria-haspopup="true"
                  aria-expanded={download ? "true" : undefined}
                  onClick={handleClicks}
                >
                  <FileDownloadIcon />
                  Download
                </Button>
                <Menu
                  id="basic-menu"
                  anchorEl={downloadEl}
                  open={download}
                  onClose={handleCloses}
                  MenuListProps={{
                    "aria-labelledby": "basic-button",
                  }}
                >
                  <MenuItem onClick={handleCloses}>Header Level Excel</MenuItem>
                  <MenuItem onClick={handleCloses}>
                    Line Item Level Excel
                  </MenuItem>
                  <MenuItem onClick={handleCloses}>PO PDF</MenuItem>
                </Menu>
              </div>
              <Link to="/admin/vendor-asnVendorList" style={{ textDecoration: "none" }}>
              <button className="btn btn-danger">Back</button>
              </Link>  
            </div>
          </div>

          <div className="lets_head_purchase_number_buyer_react_blocklist">
            <div className="first_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={podetailImage} alt="" />
                  <p className="lets_block_react_details_purchase">
                    ASN Number : 00701
                  </p>
                </div>
                <div className="lets_pending_react_body">
                  Order Date :
                  <span className="date_solutions"> 19-04-2024 </span>
                  <div className="solution_asen_statsu_pending">
                    Status :<p className="date_solutions_status">Pending</p>
                  </div>
                </div>
              </div>
              <div className="lets_table_buyername_react_suntech">
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      PO Number
                    </td>
                    <td>:</td>
                    <td>00701</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Vendor Name
                    </td>
                    <td>:</td>
                    <td>Suntech Solutions</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Company ID
                    </td>
                    <td>:</td>
                    <td>GHJ6781</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      ASN Quantity
                    </td>
                    <td>:</td>
                    <td>8</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Recevied Quantity
                    </td>
                    <td>:</td>
                    <td>3</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Pending Quantity
                    </td>
                    <td>:</td>
                    <td>5</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react_id">
                      Total Quantity
                    </td>
                    <td>:</td>
                    <td>2</td>
                  </tr>
                </table>
                <table>
                  <tr>
                    <td>Vendor Code</td>
                    <td>:</td>
                    <td>GHJ6781</td>
                  </tr>
                  <tr>
                    <td>Payment Terms</td>
                    <td>:</td>
                    <td>Net 30</td>
                  </tr>
                  <tr>
                    <td>Expected Delivery Date</td>
                    <td>:</td>
                    <td>12/03-2024</td>
                  </tr>
                  <tr>
                    <td>Last Updated</td>
                    <td>:</td>
                    <td>12/03-2024</td>
                  </tr>
                  <tr>
                    <td>Bill To</td>
                    <td>:</td>
                    <td>Delhi</td>
                  </tr>
                  <tr>
                    <td>Ship To</td>
                    <td>:</td>
                    <td>Mumbai</td>
                  </tr>
                  <tr>
                    <td>Valid From</td>
                    <td>:</td>
                    <td>12/03-2024</td>
                  </tr>
                  <tr>
                    <td>Valid To</td>
                    <td>:</td>
                    <td>12/03-2024</td>
                  </tr>
                  <tr>
                    <td>Last Modify Date</td>
                    <td>:</td>
                    <td>19-04-2024</td>
                  </tr>
                </table>
              </div>
            </div>
            <div className="second_podetail_basic_block_level_reacts">
              <div className="lets_react_order_listing_level_buyer">
                <div className="content_react_level_details">
                  <img src={summaryImage} alt="" />
                  <p className="lets_block_react_details_purchase">Summary</p>
                </div>
              </div>
              <div>
                <table>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Total Amount
                    </td>
                    <td>:</td>
                    <td>₹35,600</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Texable Value
                    </td>
                    <td>:</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">CGST</td>
                    <td>:</td>
                    <td>9%</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      SGST/UTGST
                    </td>
                    <td>:</td>
                    <td>18%</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Total TCS Value
                    </td>
                    <td>:</td>
                    <td>1</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Freight Charge
                    </td>
                    <td>:</td>
                    <td>₹0.00</td>
                  </tr>
                  <tr>
                    <td className="name_asn_details_suntech_react">
                      Grand Total
                    </td>
                    <td>:</td>
                    <td>₹ 35,600</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
          <div className="search_filter_outers_react ms-auto">
            <div className="search_main">
              <div id="custom-search-input">
                <div className="input-group col-md-12">
                  <input
                    type="text"
                    className="form-control input-lg"
                    placeholder="Search here"
                    fdprocessedid="8achb"
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-info btn-lg"
                      type="button"
                      fdprocessedid="trsp06"
                    >
                      <span className="glyphicon glyphicon-search">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-search"
                          viewBox="0 0 16 16"
                        >
                          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                        </svg>
                      </span>
                    </button>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className="listing_main listing_main_dragdropcontext_body" style={{ overflowX: "scroll", marginTop: "-15px" }}>
          <table className="dragdropcontext_ondragend_block_arrow">
          <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <tr>
                  <th className="vendor_tabels">
                    <input type="checkbox" />
                  </th>
                  {columns.map((column, index) => (<>
                    <th className="vendor_tabels ">
                      <div className="PoDetailTableHeading">
                        <div className="d-flex">
                          <p>{column?.label}</p>
                          {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                            {(column.sortLabel != "asc") && <img src={topArrow} />}
                            {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                            {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                            {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                          </span>}
                        </div>
                      </div>
                    </th>
                  </>))}
                </tr>
              </thead>
              <tbody style={{ overflowY: "scroll", width: "200px" }}>
                <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>

                  <td className="block_solar">00702</td>
                  <td>Chinese masala</td>
                  <td>BGHHX01</td>
                  <td>230</td>
                  <td>5</td>
                  <td>5</td>
                  <td><input type="text" className="form-control form-ha" /></td>
                  <td>2</td>
                  <td>₹ 35,600</td>
                </tr>
                <tr className="maine_tr_vendor">
                  <td>
                    <input type="checkbox" />
                  </td>
                  <td className="block_solar">00702</td>
                  <td>Chinese masala</td>
                  <td>BGHHX01</td>
                  <td>230</td>
                  <td>5</td>
                  <td>5</td>
                  <td> <input type="text" className="form-control form-ha" /></td>
                  <td>2</td>
                  <td>₹ 35,600</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select className="form-select packagelrlisting from-hs">
                <option selected="1">10</option>
                <option value="2">15</option>
                <option value="3">20</option>
                <option value="4">25</option>
                <option value="5">50</option>
              </select>
              <span className="react_text_showing">
                &nbsp;Showing lrListingrows 1 to&nbsp;10 of&nbsp;10
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={qcListing?.totalPages}
                page={qcListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === qcListing?.currentPage) {
                    return (
                      <input
                        className="form-control form-hasw"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          {/* Submit sucessfully Modal  */}
          <Modal
            open={openasnsubmitsuccessfully}
            onClose={() => setOpenAsnSubmitSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={checkcircleImage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Submited</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. :<b> 07001 |</b> ASN Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnSubmitSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          {/* Cancel sucessfully Modal  */}
          <Modal
            open={openasncancelsuccessfully}
            onClose={() => setOpenAsnCancelSuccessfullys(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnCancelSuccessfullys(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={rejectImage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Cancel</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. :<b> 07001 |</b> ASN Amount : <b>₹35,600 |</b> ASN
                      Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnCancelSuccessfullys(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          <div className="two_btn_cancel_solutions">
            <button
              class="view_failed"
              fdprocessedid="vsrcbk"
              onClick={setOpenAsnCancelSuccessfullys}
            >
              Cancel
            </button>
            <button
              class="view_success"
              fdprocessedid="5m4v4"
              onClick={setOpenAsnSubmitSuccessfullys}
            >
              Submit
            </button>
          </div>
        </div>
        <SupportChat
          vendorDetails={{ vendor: { _id: "667bb2852cf8382719badf09" } }}
        />
      </div>
    </>
  );
}

export default AsnDetail;
